const getters = {
  assigned_templates: (state) => state.assigned_templates,
  have_assigned_templates: (state) => state.have_assigned_templates,
}

export default getters
